import React from "react";
import {AssetSearchFilters} from "../../packages/asset/mng/info/shared/AssetSearchFilters";

/** SearchSelector children 으로 쓰이는 필터 묶음 컴포넌트 — 내부 SimmsDrawerSearch 를 펼쳐 파싱 */
const FILTER_WRAPPER_TYPES = new Set([AssetSearchFilters]);

function collectFilterElements(children, out) {
    React.Children.forEach(children, (child) => {
        if (!React.isValidElement(child)) return;

        // Fragment 등 wrapper는 내부 children을 펼쳐서 검사
        if (child.type === React.Fragment) {
            collectFilterElements(child.props?.children, out);
            return;
        }

        if (FILTER_WRAPPER_TYPES.has(child.type)) {
            const expanded = child.type(child.props);
            collectFilterElements(expanded, out);
            return;
        }

        out.push(child);
    });
}

export function parseSearchSelectorFilters(children) {
    const filters = [];

    const nodes = [];
    collectFilterElements(children, nodes);

    nodes.forEach((child) => {
        if (child.props?.type === "TEXT" || child.props?.type === "HIDDEN") return;
        if (!child.props?.entity || !child.props?.target) return;

        filters.push({
            target: child.props.target,
            title: child.props.title ?? child.props.target,
            entity: child.props.entity,
            recursive: !!child.props.recursive,
            uniqueKey: child.props.uniqueKey,
            parentKey: child.props.parentKey,
        });
    });

    return filters;
}
